module.exports = __webpack_public_path__ + "img/deleteButtonW.97a5da4a.png";